// extracted by mini-css-extract-plugin
export var addButton = "_5g-d";
export var bullets = "_5g-e";
export var compact = "_5g-2";
export var container = "_5g-j";
export var extendedWarrantyModal = "_5g-f";
export var learn = "_5g-l";
export var learnMore = "_5g-g";
export var offeringOption = "_5g-3";
export var offeringPrice = "_5g-8";
export var offeringSubtitle = "_5g-7";
export var offeringTitle = "_5g-6";
export var offeringsContainer = "_5g-0";
export var pdpTilesBackground = "_5g-n";
export var plan = "_5g-m";
export var regular = "_5g-1";
export var remove = "_5g-k";
export var seeDetailsIcon = "_5g-i";
export var seeDetailsLink = "_5g-h";
export var selectedOption = "_5g-4";
export var shieldIcon = "_5g-b";
export var shieldIconCompact = "_5g-c";
export var subtitle = "_5g-a";
export var title = "_5g-9";
export var unselectedOption = "_5g-5";